import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="stream-link-notice"
export default class extends Controller {
  static values = {
    modalUrl: String,
  }

  open() {
    const turboFrame = document.getElementById("modal_content")
    if (turboFrame) {
      turboFrame.src = this.modalUrlValue
    }
  }
}
